// extracted by mini-css-extract-plugin
export default {"checkboxSVG":"abtFQ Rqmx9","checkboxSvg":"abtFQ Rqmx9","checkbox-container":"MzwYx","checkboxContainer":"MzwYx"};